var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IntegrationOrgInfo_1;
import { DateConverter, JSON, JsonConverter, JsonSchema } from '@symon-ai/wisepipe-serialize';
import './integrationEventQueue';
import { IntegrationQueueType } from './integrationEventQueue';
export var IntegrationType;
(function (IntegrationType) {
    IntegrationType["Incentives"] = "incentives";
})(IntegrationType || (IntegrationType = {}));
const schema = {
    $id: 'urn:wisepipe-domain-authorize:IntegrationOrgInfo',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        source: {
            type: 'string',
            minLength: 1
        },
        sourceID: { type: 'string' },
        createdAt: { type: 'string', format: 'date-time' },
        integrationType: { type: 'string', enum: Object.values(IntegrationType) },
        sqsQueueUrl: { type: 'string' },
        eventQueues: { type: 'array', items: { $ref: 'urn:wisepipe-domain-authorize:IntegrationEventQueue' } }
    },
    required: ['orgID', 'source', 'sourceID']
};
let IntegrationOrgInfo = IntegrationOrgInfo_1 = class IntegrationOrgInfo {
    constructor(orgID, source, sourceID, createdAt, integrationType, sqsQueueUrl, eventQueues) {
        this.orgID = orgID;
        this.source = source;
        this.sourceID = sourceID;
        this.createdAt = createdAt;
        this.integrationType = integrationType;
        this.sqsQueueUrl = sqsQueueUrl;
        this.eventQueues = eventQueues;
        JSON.validate(this, IntegrationOrgInfo_1);
    }
    getSnsTopicArn(integrationEventType) {
        return this.eventQueues?.find((queue) => queue.integrationEventType === integrationEventType && queue.integrationQueueType === IntegrationQueueType.Sns)?.snsTopicArn;
    }
    getSqsQueueUrl(integrationEventType) {
        return this.eventQueues?.find((queue) => queue.integrationEventType === integrationEventType && queue.integrationQueueType === IntegrationQueueType.Sqs)?.sqsQueueUrl;
    }
    getSqsDLQUrl(integrationEventType) {
        return this.eventQueues?.find((queue) => queue.integrationEventType === integrationEventType &&
            queue.integrationQueueType === IntegrationQueueType.SqsDLQ)?.sqsQueueUrl;
    }
    getKinesisStreamArn(integrationEventType) {
        return this.eventQueues?.find((queue) => queue.integrationEventType === integrationEventType)?.kinesisStreamArn;
    }
};
__decorate([
    JsonConverter(new DateConverter('date-time'))
], IntegrationOrgInfo.prototype, "createdAt", void 0);
IntegrationOrgInfo = IntegrationOrgInfo_1 = __decorate([
    JsonSchema(schema)
], IntegrationOrgInfo);
export { IntegrationOrgInfo };
//# sourceMappingURL=integrationOrgInfo.js.map